import {
  getResponsivePaddingStyleTag,
  getResponsiveValueStyleTag,
  getResponsiveMarginStyleTag,
  getImagePositionStyleTag,
  getTextStylesStyleTag,
  getGridColumnsStyleTag,
} from './responsive-utils';
import { getImageProps } from './image-props';
import {
  nullToUndefined,
  sanitizeSanityValue,
  convertNullsToUndefined,
} from './sanity-null-converter';
import { getHighlightSpanProps } from './highlight-span-props';

export const utils = {
  highlightSpanProps: {
    getHighlightSpanProps,
  },
  responsiveUtils: {
    getResponsivePaddingStyleTag,
    getResponsiveValueStyleTag,
    getResponsiveMarginStyleTag,
    getImagePositionStyleTag,
    getTextStylesStyleTag,
    getGridColumnsStyleTag,
  },
  imageProps: {
    getImageProps,
  },
  sanityNullConverter: {
    nullToUndefined,
    sanitizeSanityValue,
    convertNullsToUndefined,
  },
};
